module.exports = __webpack_public_path__ + "static/media/join-us.03857c07.png";